import React from 'react';

import { DASHBOARD_PAGE_PATH } from '../constants/appPathConst';
import PageSpinner from '../components/GeneralForm/PageSpinner';
import { REGISTERED_TRADEMARK_SYMBOL, TM_TRADEMARK_SYMBOL } from '../constants/messageConst';
import { IMG_AP_LOGO_LIGHT_WITHOUT_TITLE } from '../constants/imagesAssetsConst';
import CustomButton from '../components/GeneralForm/CustomButton';

const NAME = `Autoport ${REGISTERED_TRADEMARK_SYMBOL}`;

const Logo = () => (
  <div className="mb-4 text-center">
    <CustomButton isLinkTag to={DASHBOARD_PAGE_PATH}>
      <img src={IMG_AP_LOGO_LIGHT_WITHOUT_TITLE} alt={NAME} width="100" />
    </CustomButton>
  </div>
);
const Footer = () => (
  <div>
    <p className="small text-muted text-center">
      (C) {new Date().getFullYear()} All Rights Reserved.
      <CustomButton
        isAnchorTag
        to="https://autoport.dealerimagepro.com"
        target="_blank"
        rel="noreferrer noopener"
      >
        {NAME}
      </CustomButton>
      <br />
      <CustomButton isAnchorTag to="https://dealerimagepro.com" target="_blank" rel="noreferrer noopener">
        Dealer Image Pro{TM_TRADEMARK_SYMBOL}
      </CustomButton>
      <br />
    </p>
  </div>
);

const FullLayout = props => {
  const isLightTheme = props.themeArr.isLightTheme || false;
  return (
    <div className="fullscreen">
      <PageSpinner isLoading={props?.isLoading} isMainLayout={false} />
      <div className="fullscreen__section">
        <div className="fullscreen__section--center">
          <div className="fullscreen__section__child">
            <div className="mb-4">
              <Logo isLightTheme={isLightTheme} />
              {props.children}
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FullLayout.displayName = 'FullLayout';
export default FullLayout;
